// extracted by mini-css-extract-plugin
export default {"search-bar-container-home-page":"bSNzkG","searchBarContainerHomePage":"bSNzkG"};